import { Transition, motion } from 'framer-motion'
import { Logo, Spinner, View } from './styled'

const transition: Transition = {
  type: 'tween',
  ease: 'easeIn',
  duration: 0.4,
}

export const Loader = () => (
  <View exit={{ opacity: 0, transition: { delay: 0.5, ...transition } }}>
    <motion.div exit={{ opacity: 0, translateY: '-1rem', transition }}>
      <Logo />
    </motion.div>
    <Spinner
      exit={{
        opacity: 0,
        translateY: '-1rem',
        transition: { delay: 0.2, ...transition },
      }}
    />
  </View>
)
